import { http } from '@pendo/http';
import { mapPermission } from '@/stores/helpers/saved-reports.helper';
const reportsApi = '/api/s/_SID_/report';
const workflowsApi = '/api/s/_SID_/workflow';

export function createReport (report) {
    return http.post(reportsApi, report);
}

export function deleteReport (id) {
    return http.delete(`${reportsApi}/${id}`);
}

export function fetchReport (id) {
    return http.get(`${reportsApi}/${id}`);
}

export function fetchReports (type = null) {
    if (!type) return http.get(`${reportsApi}`);

    return http.get(reportsApi, {
        params: {
            type,
        },
    });
}

export function updateReport (report, skipVersioning = false) {
    return http.put(`${reportsApi}/${report.id}?skipVersioning=${skipVersioning}`, report);
}

// Util functions
export async function createWorkflow (workflow) {
    const response = await http.post(workflowsApi, mapPermission(workflow));

    try {
        await http.post(`${workflowsApi}/${response.data.id}/apply`, {});
    } catch {
        // Don't worry about errors from the apply endpoint. No need to bubble that up to the user.
    }

    return response.data;
}

export function deleteWorkflow (id) {
    return http.delete(`${workflowsApi}/${id}`);
}

export function fetchAllWorkflowsForSubscription (excludeJourneyDefinition = true) {
    if (excludeJourneyDefinition) {
        return http.get(`${workflowsApi}?excludeJourneyDefinition=true`).then((res) => res.data);
    }

    return http.get(workflowsApi).then((res) => res.data);
}

export function fetchWorkflowForSubscription (id) {
    return http
        .get(`${workflowsApi}/${id}`)
        .then((res) => res.data)
        .catch((err) => {
            console.error('Error fetching workflow', err);

            throw err;
        });
}

export async function updateWorkflow (savedWorkflow, updatedWorkflow, applyToAggregation) {
    const url = `${workflowsApi}/${updatedWorkflow.id}`;
    const response = await http.put(url, mapPermission(updatedWorkflow));
    if (!applyToAggregation) {
        return response.data;
    }
    try {
        // This only needs to be called when the agg params change
        await http.post(`${url}/apply`, {});
    } catch {
        // Don't worry about errors from the apply endpoint. No need to bubble that up to the user.
    }

    return response.data;
}

export function cancelReport (id) {
    return http.post(`${reportsApi}/${id}/cancel`, {});
}

export function cancelWorkflow (id) {
    return http.post(`${workflowsApi}/${id}/cancel`, {});
}
